import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const getConfig = () => client.get("/config").then((r) => r.data);
export const calculate = (payload) => client.post("/calculate", payload).then((r) => r.data);
export const compare = (payload) => client.post("/compare", payload).then((r) => r.data);
export const calcEmi = (payload) => client.post("/emi", payload).then((r) => r.data);
export const getEstimate = (id) => client.get(`/estimate/${id}`).then((r) => r.data);
export const checkPmay = (payload) => client.post("/pmay", payload).then((r) => r.data);

export const inr = (n) =>
  new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 }).format(Math.round(n || 0));

export const inrShort = (n) => {
  n = Number(n) || 0;
  if (n >= 10000000) return `₹${(n / 10000000).toFixed(2)} Cr`;
  if (n >= 100000) return `₹${(n / 100000).toFixed(2)} L`;
  if (n >= 1000) return `₹${(n / 1000).toFixed(1)}K`;
  return `₹${n}`;
};

export const num = (n) =>
  new Intl.NumberFormat("en-IN", { maximumFractionDigits: 1 }).format(n || 0);
